// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__oFPi3","open":"Burger_open__J88Tq"};